export default {
	"DB_NAME": "cafsdb",
	"DB_VERSION": 3
}
